<template >
  <div class="labelCont productCategoryDome">
    <div class="categoryCont">
      <div class="treeCont">
        <!-- 树形菜单 -->
        <div class="categoryTree">
          <div style="cursor: pointer; margin: 5px 0 0 18px; color: #2D8CF0;" v-if="categoryTree.length>0" @click="exchangeTree">{{ showTree ? '全部收起' : '全部展开' }}
          </div>
          <Tree ref="categoryTree" :load-data="loadData" :data="categoryTree" @on-select-change="view" @on-toggle-expand="changeExpand" @on-check-change="checkDateHandel"></Tree>
          <Spin v-if="loading3" fix></Spin>
        </div>
        <div class="categoryBtn">
          <Button :disabled="!viewMode || productCategory.productCategoryId == null || productCategory.productCategoryId == -1" type="primary" icon="edit" @click="edit">编辑 </Button>
          <Button :disabled="!viewMode || productCategory.productCategoryId == null" type="primary" icon="md-add" @click="add">新增子分类 </Button>
          <Button :disabled="!viewMode || productCategory.productCategoryId == null || productCategory.productCategoryId == -1" type="primary" icon="trash-a" @click="delConfirm">删除 </Button>
          <div class="categoryBatchBtn">
            批量处理:
            <!-- <Button>删除</Button>-->
            <Button @click="exportCategory" v-if="getPermission('productCategory_export')">导出 </Button>
          </div>
        </div>
      </div>
      <!-- 分割线 -->
      <div class="line"></div>
      <!-- 详细信息 -->
      <div class="categoryDetail">
        <div class="categoryDetailCont">
          <div>
            <div class="categoryDetailTitle">基础分类信息</div>
            <Form ref="productCategory" :model="productCategory" :label-width="120" label-position="right"
              class="categoryForm">
              <div class="form-col-item">
                <Form-item label="分类ID:" :rules="{ required: true, message: '分类ID不能为空', trigger: 'blur' }"
                  prop="productCategoryCode">
                  <dyt-input :style="`${inputWidth}`" :maxlength="50" v-model.trim="productCategory.productCategoryCode"
                    :disabled="viewMode"></dyt-input>
                </Form-item>
                <Form-item label="分类中文名称:" :rules="{ required: true, validator: cnameValidator, trigger: 'blur' }"
                  prop="cnName">
                  <dyt-input :style="`${inputWidth}`" :maxlength="50" v-model.trim="productCategory.cnName"
                    :disabled="viewMode"></dyt-input>
                </Form-item>
                <Form-item label="分类英文名称:" prop="enName">
                  <dyt-input :style="`${inputWidth}`" :maxlength="100" v-model.trim="productCategory.enName"
                    :disabled="viewMode"></dyt-input>
                </Form-item>
                <Form-item label="报关编码:" prop="hsCode"
                  :rules="{ required: true, validator: hsCodeVerify, msg: '请输入报关编码', minLength: 10, maxLength: 10, trigger: 'blur' }">
                  <dyt-input :style="`${inputWidth}`" :maxlength="10" v-model.trim="productCategory.hsCode"
                    :disabled="viewMode"></dyt-input>
                </Form-item>
                <Form-item label="中文报关名称:" prop="cnHsName"
                  :rules="{ required: true, validator: hsNameMaxVerify, msg: '请输入中文报关名称', maxLength: 200, trigger: 'blur' }">
                  <dyt-input :style="`${inputWidth}`" :maxlength="200" v-model.trim="productCategory.cnHsName"
                    :disabled="viewMode"></dyt-input>
                </Form-item>
                <Form-item label="英文报关名称:" prop="enHsName"
                  :rules="{ required: true, validator: enNameMaxVerify, msg: '请输入英文报关名称', maxLength: 200, trigger: 'blur' }">
                  <dyt-input :style="`${inputWidth}`" :maxlength="200" v-model.trim="productCategory.enHsName"
                    :disabled="viewMode"></dyt-input>
                </Form-item>
                <!-- <FormItem v-if="!viewMode">
                <Button type="primary" @click="save()">保存 </Button>
                <Button @click="cancel()" style="margin-left: 8px">取消 </Button>
              </FormItem> -->
              </div>
              <div class="form-col-item">
                <Form-item label="分类类型:" prop="productType"
                  :rules="{ required: true, message: '分类类型不能为空', trigger: 'submit', type: 'string' }">
                  <dyt-select :style="`${inputWidth}`" v-model="productCategory.productType" :disabled="viewMode"
                    placeholder="请选择分类类型">
                    <Option v-for="(item, key) in classTypeList" :value="item.productType" :key="key">{{ item.configName
                      }}</Option>
                  </dyt-select>
                </Form-item>
                <Form-item label="尺码类型:" prop="sizeType">
                  <dyt-select :style="`${inputWidth}`" v-model="productCategory.sizeType" :disabled="viewMode"
                    placeholder="请选择尺码类型">
                    <Option v-for="(item, key) in sizeList" :value="item.sizeTypeId" :key="key">{{ item.typeName }}
                    </Option>
                  </dyt-select>
                </Form-item>
                <Form-item label="分类尺码:" prop="classificationId">
                  <dyt-select :style="`${inputWidth}`" v-model="productCategory.classificationId" :disabled="viewMode"
                    placeholder="请选择分类尺码">
                    <Option v-for="(item, index) in classificationDataList" :value="item.classificationId"
                      :key="`classId-${index}`">{{ item.classificationName }}</Option>
                  </dyt-select>
                </Form-item>
                <Form-item label="绑定属性:" prop="attributeId">
                  <dyt-select :style="`${inputWidth}`" v-model="productCategory.attributeId"
                    :disabled="viewMode || !getPermission('queryProductCategoryProductAttribute')">
                    <template v-for="(item, index) in attributeList">
                      <Option v-if="item" :value="item.classificationId" :key="`${index}`">{{ item.classificationName }}
                      </Option>
                    </template>
                  </dyt-select>
                </Form-item>
                <Form-item label="绑定质检模板:" prop="qualityClassificationId">
                  <dyt-select :style="`${inputWidth}`" placement='top' v-model="productCategory.qualityClassificationId"
                    :disabled="viewMode">
                    <template v-for="(item, index) in classifyList">
                      <Option v-if="item" :value="item.qualityClassificationId" :key="`${index}`">
                        {{ item.qualityClassification }}</Option>
                    </template>
                  </dyt-select>
                </Form-item>
                <Form-item label="描述:" prop="description">
                  <dyt-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" :style="`${inputWidth}`"
                    :maxlength="500" v-model.trim="productCategory.description" :disabled="viewMode"></dyt-input>
                </Form-item>
              </div>
            </Form>
          </div>
          <div>
            <div class="categoryDetailTitle">第三方平台类目映射</div>
            <Form ref="platformCategoryForm" :model="platformCategoryForm" :label-width="120" label-position="right" class="platform-category-form">
              <!-- BOL 平台类目映射 -->
              <div class="platform-category-card">
                <div class="platform-category-header">
                  <div class="platform-category-name">BOL</div>
                  <span
                    class="platform-category-status"
                    :class="{ 'platform-category-status-mapped': getPlatformMappingStatus('bol') }"
                  >
                    {{ getPlatformMappingStatus('bol') ? '已映射' : '未映射' }}
                  </span>
                </div>
                <FormItem label="BOL类目:" prop="bol.categoryPath">
                  <PlatformCategorySelect
                    ref="platform-category-select-bol"
                    v-model="platformCategoryForm.bol.categoryPath"
                    platform="bol"
                    :disabled="viewMode"
                    placeholder="请选择BOL平台对应类目"
                    @load-complete="(code) => handlePlatformLoadComplete(code, 'bol')"
                  />
                </FormItem>
              </div>
              <!-- OTTO 平台类目映射 -->
              <div class="platform-category-card">
                <div class="platform-category-header">
                  <div class="platform-category-name">OTTO</div>
                  <span
                    class="platform-category-status"
                    :class="{ 'platform-category-status-mapped': getPlatformMappingStatus('otto') }"
                  >
                    {{ getPlatformMappingStatus('otto') ? '已映射' : '未映射' }}
                  </span>
                </div>
                <FormItem label="OTTO类目:" prop="otto.categoryPath">
                  <PlatformCategorySelect
                    ref="platform-category-select-otto"
                    v-model="platformCategoryForm.otto.categoryPath"
                    platform="otto"
                    :disabled="viewMode"
                    placeholder="请选择OTTO平台对应类目"
                    @load-complete="(code) => handlePlatformLoadComplete(code, 'otto')"
                  />
                </FormItem>
              </div>
              <!-- KAUFLAND 平台类目映射 -->
              <div class="platform-category-card">
                <div class="platform-category-header">
                  <div class="platform-category-name">KAUFLAND</div>
                  <span
                    class="platform-category-status"
                    :class="{ 'platform-category-status-mapped': getPlatformMappingStatus('kaufland') }"
                  >
                    {{ getPlatformMappingStatus('kaufland') ? '已映射' : '未映射' }}
                  </span>
                </div>
                <FormItem label="KAUFLAND类目:" prop="kaufland.categoryPath">
                  <PlatformCategorySelect
                    ref="platform-category-select-kaufland"
                    v-model="platformCategoryForm.kaufland.categoryPath"
                    platform="kaufland"
                    :disabled="viewMode"
                    placeholder="请选择KAUFLAND平台对应类目"
                    @load-complete="(code) => handlePlatformLoadComplete(code, 'kaufland')"
                  />
                </FormItem>
              </div>
            </Form>
          </div>
        </div>
        <div class="categoryDetailBtn">
          <div>
            <Button type="primary" @click="save()">保存分类与映射配置 </Button>
            <Button @click="cancel()" style="margin-left: 8px">取消 </Button>
          </div>
        </div>
      </div>
    </div>
    <delConfirmModal ref="delConfirmModal" @ok="del"></delConfirmModal>
  </div>
</template>

<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import productMixin from '@/components/mixin/product_mixin';
import delConfirmModal from './delConfirmModal';
import PlatformCategorySelect from '@/components/common/platformCategorySelect';

export default {
  mixins: [Mixin, productMixin],
  components: {
    delConfirmModal: delConfirmModal,
    PlatformCategorySelect: PlatformCategorySelect
  },
  data () {
    let v = this;
    return {
      // inputWidth: 'width: calc(100% - 48px); max-width: 300px;',
      inputWidth: '100%',
      classificationDataList: [],
      attributeList: [],
      classifyList: [], // 质检分类
      showTree: true,
      loading3: false,
      selectedNode: [],
      viewMode: true, // 是否查看模式
      checkedTreeDate: [], // 已选择树分类
      selectedProductCategory: null, // 当前选中的分类
      productCategory: { // 分类表单模型
        productCategoryCode: null,
        classificationId: '', // 分类尺码id
        cnName: null,
        enName: null,
        sizeType: null,
        productType: '', // 分类类型
        hsCode: null,
        cnHsName: null,
        enHsName: null,
        description: null,
        attributeId: '',
        productCategoryId: -1,
        qualityClassificationId: '' // 质检分类id
      },
      oldProductCategory: {},
      categoryTree: [ // 分类树
        {
          title: '全部分类',
          expand: true,
          productCategoryId: -1,
          render (h, { root, node, data }) {
            return h('span', {
              class: 'hover-color-ccc',
              on: {
                'click' () {
                  v.selectedNode = data;
                  v.productCategory.productCategoryId = -1;
                  v.view([data]);
                }
              }
            }, '全部分类');
          },
          children: []
        }
      ],
      nameToObject: {},
      sizeList: [],
      classTypeList: [],
      // 第三方平台类目映射表单模型，独立于基础分类信息表单
      // 平台类目加载、懒加载、搜索等能力由 PlatformCategorySelect 组件内部处理
      platformCategoryForm: {
        bol: {
          categoryPath: [],
          categoryPathDetail: []
        },
        otto: {
          categoryPath: [],
          categoryPathDetail: []
        },
        kaufland: {
          categoryPath: [],
          categoryPathDetail: []
        }
      },
      // 平台类目绑定关系主键映射（来自 platformCategoryRel/list）
      // 保存时需要回传 id，用于区分新增/更新
      platformRelIdMap: {}
    };
  },
  created: function () {
    this.getProductType()
  },
  methods: {
    cnameValidator (rule, value, callback) {
      if (['', null, undefined].includes(this.productCategory.cnName)) {
        return callback(new Error('分类中文名称不能为空'));
      } else if (this.productCategory.cnName.indexOf('->') > -1) { // 不能包含->特殊字符
        return callback(new Error('不能包含->特殊字符'));
      } else {
        callback();
      }
    },
    checkDateHandel (data) {
      let v = this;
      v.checkedTreeDate = data;
    },
    getProductType() {
      this.axios.post('/pds-service/pds/lapa/workbench/product/getNotDeleteSpuConfig').then(res => {
        if (res.data.code === 0) {
          this.classTypeList = res.data.datas
        }
      })
    },
    // 第三方平台类目映射默认表单数据
    getDefaultPlatformCategoryForm () {
      return {
        bol: {
          categoryPath: [],
          categoryPathDetail: []
        },
        otto: {
          categoryPath: [],
          categoryPathDetail: []
        },
        kaufland: {
          categoryPath: [],
          categoryPathDetail: []
        }
      };
    },
    // 平台编码映射：组件内使用 kaufland，接口使用 real
    getPlatformCodeMap () {
      return {
        bol: 'bol',
        otto: 'otto',
        kaufland: 'real'
      };
    },
    getComponentPlatformCode (apiPlatformId) {
      const map = this.getPlatformCodeMap();
      return Object.keys(map).find(key => map[key] === apiPlatformId) || apiPlatformId;
    },
    // 默认平台绑定关系 id 映射
    getDefaultPlatformRelIdMap () {
      return { bol: null, otto: null, kaufland: null };
    },
    // 根据平台类目路径判断是否已映射
    getPlatformMappingStatus (platformCode) {
      const platformInfo = this.platformCategoryForm[platformCode] || {};
      return !this.$common.isEmpty(platformInfo.categoryPath);
    },
    // 平台下拉组件加载完成事件占位（后续可加 loading 状态、日志埋点等）
    handlePlatformLoadComplete (platformCode, formKey) {
      // 当前业务侧不需要额外处理；保留这个钩子便于后续扩展
    },
    // 将后端保存的每级类目明细反推为 categoryPath，供 PlatformCategorySelect 回显
    // PlatformCategorySelect 自身会根据 value 主动加载数据 + 补全路径上节点
    syncPlatformCategoryForm (mapping = {}) {
      const platformCategoryForm = this.getDefaultPlatformCategoryForm();
      Object.keys(platformCategoryForm).forEach(platformCode => {
        const categoryPathDetail = mapping[platformCode] || [];
        const categoryPath = categoryPathDetail
          .slice()
          .sort((a, b) => {
            return (a.categoryLevel || 0) - (b.categoryLevel || 0);
          })
          .map(item => {
            return item.categoryId;
          });
        platformCategoryForm[platformCode] = {
          categoryPath,
          categoryPathDetail
        };
      });
      this.platformCategoryForm = platformCategoryForm;
    },
    // 根据平台分类 id 查询平台类目绑定关系，并回显到表单
    async loadPlatformCategoryRel (productCategoryId) {
      if (!productCategoryId || productCategoryId === -1) {
        this.platformRelIdMap = this.getDefaultPlatformRelIdMap();
        this.syncPlatformCategoryForm({});
        return;
      }
      try {
        const res = await this.axios.get(api.get_platformCategoryRel, {
          params: { productCategoryId }
        });
        if (res.data.code !== 0) {
          this.$Message.error(res.data.message || '查询平台类目绑定关系失败');
          return;
        }
        const list = res.data.datas || [];
        const idMap = this.getDefaultPlatformRelIdMap();
        const mapping = { bol: [], otto: [], kaufland: [] };
        for (const item of list) {
          const platformCode = this.getComponentPlatformCode(item.platformId);
          idMap[platformCode] = item.id || null;
          // platformCategoryId 存储的是从父级到子级逗号分隔的完整路径，逐级处理获取类目名称
          const idArr = String(item.platformCategoryId || '').split(',').filter(Boolean);
          const pathDetail = [];
          for (let i = 0; i < idArr.length; i++) {
            const info = await PlatformCategorySelect.getCategoryById(platformCode, idArr[i]);
            // console.log(info, 'info');
            pathDetail.push({
              categoryLevel: i + 1,
              categoryId: idArr[i],
              categoryName: info ? info.categoryName : '',
              parentCategoryId: i === 0 ? null : idArr[i - 1]
            });
          }
          mapping[platformCode] = pathDetail;
        }
        this.platformRelIdMap = idMap;
        this.syncPlatformCategoryForm(mapping);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[loadPlatformCategoryRel] 查询失败', err);
        this.$Message.error('查询平台类目绑定关系失败');
      }
    },
    // 保存前组装第三方平台类目映射数据
    // 从 PlatformCategorySelect 组件反推 categoryPathDetail（带层级/父级 ID/名称）
    getPlatformCategoryMapping () {
      const mapping = { bol: [], otto: [], kaufland: [] };
      Object.keys(mapping).forEach(platformCode => {
        const comp = this.$refs[`platform-category-select-${platformCode}`];
        if (comp && typeof comp.getCategoryPathDetail === 'function') {
          mapping[platformCode] = comp.getCategoryPathDetail();
        }
      });
      return mapping;
    },
    // 保存平台类目绑定关系到独立接口
    async savePlatformCategoryRel (productCategoryId) {
      if (!productCategoryId) return;
      const mapping = this.getPlatformCategoryMapping();
      const platformCodeMap = this.getPlatformCodeMap();
      const list = [];
      Object.keys(mapping).forEach(platformCode => {
        const detail = mapping[platformCode] || [];
        // console.log(detail, 'detail');
        // if (!detail.length) return;
        detail.sort((a, b) => (a.categoryLevel || 0) - (b.categoryLevel || 0));
        // platformCategoryId 保存从父级到子级的每一层分类 ID，逗号分隔
        const platformCategoryId = detail.map(d => String(d.categoryId)).join(',');
        list.push({
          id: this.platformRelIdMap[platformCode] || undefined,
          productCategoryId: String(productCategoryId),
          platformId: platformCodeMap[platformCode],
          platformCategoryId: platformCategoryId,
        });
      });
      if (!list.length) return;
      try {
        const res = await this.axios.post(api.save_platformCategoryRel, list);
        if (res.data.code !== 0) {
          this.$Message.error(res.data.message || '保存平台类目绑定关系失败');
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[savePlatformCategoryRel] 保存失败', err);
        this.$Message.error('保存平台类目绑定关系失败');
      }
    },
    // 基础分类信息表单校验
    validateCategoryForm () {
      return new Promise(resolve => {
        this.$refs.productCategory.validate((valid) => {
          resolve(valid);
        });
      });
    },
    // 第三方平台类目映射独立表单校验
    validatePlatformCategoryForm () {
      return new Promise(resolve => {
        this.$refs.platformCategoryForm.validate((valid) => {
          resolve(valid);
        });
      });
    },
    // 保存时同时校验基础分类信息和第三方平台类目映射
    async validateAllCategoryForm () {
      const valid = await this.validateCategoryForm();
      const platformValid = await this.validatePlatformCategoryForm();
      return valid && platformValid;
    },
    // 将第三方平台类目映射写入分类保存参数
    setPlatformCategoryMapping () {
      this.$set(this.productCategory, 'platformCategoryMapping', this.getPlatformCategoryMapping());
    },
    exportCategory () {
      let v = this;
      v.axios.post(api.export_productCategory).then((res) => {
        if (res.data.code === 0) {
          v.$Message.success('导出成功');
        }
      }).catch(() => {
      });
    },
    async save () { // 保存
      let self = this;
      let v = this;
      let currentNode = self.selectedNode;
      let productCategoryId = self.productCategory.productCategoryId;
      const valid = await this.validateAllCategoryForm();
      if (!valid) return;
      // 编辑
      if (productCategoryId) {
        const hand = {
          infoSave: () => {
            self.axios.put(api.edit_productCategory, self.productCategory).then(response => {
              if (response.data.code === 0) {
                for (let key in self.productCategory) {
                  self.$set(currentNode, key, self.productCategory[key]);
                }
                self.viewMode = true;
                self.getList('update');
                self.$Message.success('更新成功');
                this.oldProductCategory = this.deepCopy(self.productCategory);
              }
            });
            // 第三方平台类目映射拆分到独立接口维护
            this.savePlatformCategoryRel(productCategoryId);
          }
        }
        if (this.oldProductCategory.attributeId && this.oldProductCategory.attributeId != this.productCategory.attributeId) {
          this.$Modal.confirm({
            title: '提示',
            content: '<p>操作存在风险，是否确认操作？</p>',
            onOk: () => {
              hand.infoSave();
            },
            onCancel: () => { }
          });
        } else {
          hand.infoSave();
        }
        // 新增
      } else {
        self.productCategory.parentId = (currentNode.productCategoryId !== -1) ? currentNode.productCategoryId : null;
        self.axios.post(api.add_productCategory, self.productCategory).then(async response => {
          if (response.data.code === 0) {
            self.getList('update');
            const children = currentNode.children || [];
            self.productCategory.expand = false;
            let { ...newCategory } = self.productCategory;
            newCategory.productCategoryId = response.data.datas;
            // 新增分类成功后，将返回的分类 id 作为 productCategoryId 保存平台类目映射
            await self.savePlatformCategoryRel(response.data.datas);
            newCategory.render = (h, { root, node, data }) => {
              return h('span', [
                h('span', {
                  style: {
                    color: 'red',
                    cursor: 'pointer'
                  }
                }, '('), h('span', {
                  class: 'hover-underline',
                  style: {
                    color: 'red',
                    cursor: 'pointer'
                  },
                  on: {
                    'click' () {
                      v.$router.push({
                        path: '/productGoods',
                        query: {
                          categoryId: data.productCategoryId
                        }
                      });
                    }
                  }
                }, 0), h('span', {
                  style: {
                    color: 'red',
                    cursor: 'pointer'
                  }
                }, ')'), h('span', {
                  class: 'hover-color-ccc',
                  on: {
                    'click' () {
                      v.selectedNode = data;
                      v.productCategory.productCategoryId = data.productCategoryId;
                      v.view([data]);
                    }
                  }
                }, data.cnName)
              ]);
            };
            children.unshift(newCategory);
            self.$set(currentNode, 'children', children);
            self.$refs['productCategory'].resetFields();
            self.$refs['platformCategoryForm'].resetFields();
            this.view([]);
            var { ...rowData } = currentNode;
            self.productCategory = rowData;
            self.loadPlatformCategoryRel(rowData.productCategoryId);
            self.viewMode = true;
            self.$Message.success('新增成功');
          }
        });
      }
    },
    cancel () { // 取消
      this.$refs['productCategory'].resetFields();
      this.$refs['platformCategoryForm'].resetFields();
      var { ...rowData } = this.selectedNode;
      this.productCategory = rowData;
      this.platformRelIdMap = this.getDefaultPlatformRelIdMap();
      this.loadPlatformCategoryRel(rowData.productCategoryId);
      this.viewMode = true;
    },
    getList () { // 获取列表数据
      this.getTypelist();

      let self = this;
      if (self.$store.state.category) {
        self.categoryTree[0].children = self.$store.state.category;
        return;
      }
      self.loading3 = true;
      this.axios.get(api.get_productCategory, { hiddenError: true }).then(resa => {
        self.loading3 = false;
        if (resa.data.code === 0) {
          self.categoryTree[0].children = self.toTree(resa.data.datas);
          self.$store.commit('category', self.categoryTree[0].children);
          self.axios.get(api.get_tagProductCount).then(resb => {
            if (resb.data.code === 0) {
              resa.data.datas.forEach(i => {
                resb.data.datas.forEach(j => {
                  if (i.productCategoryId === j.productCategoryId) {
                    i.categoryCount = j.productCount;
                  }
                });
              });
              self.$store.commit('category', self.categoryTree[0].children);
            }
          });
        }
      });
    },
    toTree (arr) {
      let v = this;
      let treeJson = {};
      let parentIdList = arr.filter(item => {
        treeJson[item.productCategoryId] = item;
        if (!item.parentId) {
          item.children = [];
          return true;
        }
        return false;
      });
      arr.forEach(i => {
        if (i.parentId && treeJson[i.parentId]) {
          if (treeJson[i.parentId].children) {
            treeJson[i.parentId].children.push(i);
          } else {
            treeJson[i.parentId].children = [i];
          }
        }
        if (!i.categoryCount) {
          i.categoryCount = 0;
        } else {
          if (i.children) {
            i.categoryCount = i.children.reduce((a, b) => {
              return b.categoryCount + a;
            }, 0);
          } else {
            i.categoryCount = i.categoryCount;
          }
        }
        i.render = (h, { root, node, data }) => {
          return h('span', [
            h('span', {
              style: {
                color: 'red',
                cursor: 'pointer'
              }
            }, '('), h('span', {
              class: 'hover-underline',
              style: {
                color: 'red',
                cursor: 'pointer'
              },
              on: {
                'click' () {
                  v.$router.push({
                    path: '/productGoods',
                    query: {
                      categoryId: data.productCategoryId
                    }
                  });
                }
              }
            }, data.categoryCount), h('span', {
              style: {
                color: 'red',
                cursor: 'pointer'
              }
            }, ')'), h('span', {
              class: 'hover-color-ccc',
              on: {
                'click' () {
                  v.selectedNode = data;
                  v.productCategory.productCategoryId = data.productCategoryId;
                  v.view([data]);
                }
              }
            }, data.cnName)
          ]);
        };
        i.expand = false;
      });
      v.sizeTypeforCatergory(parentIdList);
      return parentIdList;
    },
    // 子级分类根据母分类反显尺码类型
    sizeTypeforCatergory (list) {
      let a = (list, item) => {
        list.forEach(k => {
          if (item && (item.sizeType || item.sizeType === 0) && !(k.sizeType || k.sizeType === 0)) {
            k.sizeType = item.sizeType;
          }
          if (k.children && k.children.length) {
            a(k.children, k);
          }
        })
      }
      a(list);
    },
    view (selectedProductCategorys) { // 查看
      if (selectedProductCategorys.length === 0) {
        this.selectedProductCategory.selected = true;
      } else {
        this.productCategory = this.deepCopy(selectedProductCategorys[0]);
        this.selectedProductCategory = selectedProductCategorys[0];
        this.oldProductCategory = this.deepCopy(this.productCategory);
        // 异步加载平台类目绑定关系
        this.loadPlatformCategoryRel(this.productCategory.productCategoryId);
      }
      this.viewMode = true;
    },
    edit () { // 编辑
      if (this.getPermission('productCategory_update')) {
        this.view([]);
        this.viewMode = false;
      }
    },
    add () { // 新增
      if (this.getPermission('productCategory_insert')) {
        this.viewMode = false;
        this.productCategory = {};
        this.platformCategoryForm = this.getDefaultPlatformCategoryForm();
        this.platformRelIdMap = this.getDefaultPlatformRelIdMap();
        this.oldProductCategory = {};
      }
    },
    delConfirm () { // 删除确认
      if (this.getPermission('productCategory_delete')) {
        this.$refs.delConfirmModal.show();
      }
    },
    del () { // 删除
      let self = this;
      self.axios.delete(api.del_productCategory + self.productCategory.productCategoryId).then(response => {
        if (response.data.code === 0) {
          self.$Message.success('删除成功');
          let categoryData = this.selectedNode;
          self.removeTreeNode(null, categoryData);
          self.reset();
        }
        self.$refs.delConfirmModal.hide();
      });
    },
    reset () {
      this.productCategory = {
        productCategoryId: -1
      };
      this.platformCategoryForm = this.getDefaultPlatformCategoryForm();
      this.platformRelIdMap = this.getDefaultPlatformRelIdMap();
      this.categoryTree[0].selected = true;
    },
    removeTreeNode (parent, categoryData) { // 删除选择节点
      let self = this;
      parent = (parent !== null ? parent : self.categoryTree[0]);

      if (parent.productCategoryId === (categoryData.parentId == null ? -1 : categoryData.parentId)) {
        const index = parent.children.indexOf(categoryData);
        parent.children.splice(index, 1);
        self.$set(parent, 'children', parent.children);
        return;
      }

      let children = parent.children;

      for (let i = 0; i < children.length; i++) {
        let item = children[i];

        if (item.productCategoryId === categoryData.parentId) {
          const index = item.children.indexOf(categoryData);
          item.children.splice(index, 1);
          self.$set(item, 'children', item.children);
          break;
        }

        if (item.children && item.children.length > 0) {
          self.removeTreeNode(item, categoryData);
        }
      }
    },
    changeExpand (data) {
      if (data.nodeKey === 0) {
        this.showTree = data.expand;
      }
    },
    // 获取分类尺码列表
    getClassificationList () {
      this.axios.get(api.queryAllProductSizeClassificationList).then(res => {
        if (res && res.data && res.data.code === 0) {
          this.classificationDataList = (res.data.datas || []).map(item => {
            this.$common.isEmpty(item.classificationId) && (item.classificationId = '');
            return item
          })
        }
      })
    },
    // 展开或合并树，当flag为true时全部展开，flag为false时全部合并
    exchangeTree () {
      this.showTree = !this.showTree;
      this.categoryTree = this.treeChangeExpand(this.categoryTree, this.showTree);
    },
    // 递归给树设置expand
    treeChangeExpand (treeData, flag) {
      let v = this;
      for (let i = 0; i < treeData.length; i++) {
        v.$set(treeData[i], 'expand', flag);
        if (treeData[i].children) {
          treeData[i].children = v.treeChangeExpand(treeData[i].children, flag);
        }
      }
      return treeData;
    },
    // 获取属性分类
    productAttribute () {
      this.attributeList = [];
      this.axios.get(api.get_productAttribute).then(res => {
        if (res.data.code == 0 && res.data.datas) {
          this.attributeList = res.data.datas;
        }
      })
    },
    // 获取所有质检模板
    getAllQuality () {
      this.classifyList = [];
      this.axios.get(api.getAllQualityTemplate).then((res) => {
        if (res && res.data && res.data.code === 0) {
          this.classifyList = (res.data.datas || []).map(item => {
            return {
              ...item,
              qualityClassificationId: Number(item.qualityClassificationId)
            }
          })
        }
      })
    },
    // 获取尺码类型
    getTypelist () {
      this.axios
        .get(api.queryProductSizeTypeList, { hiddenError: true })
        .then(({ data }) => {
          if (data.code === 0) {
            this.sizeList = data.datas || [];
          }
        })
    },
    // 验证报关中文
    hsNameMaxVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.hasChinese;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('必须包含中文'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    // 验证报关英文
    enNameMaxVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.hasEnglish;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('必须包含英文'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
    hsCodeVerify(rule, value, callback) {
      const newVal = this.$common.isEmpty(value) ? '' : value.trim();
      const regex = this.$regular.AllNumber;
      if (!this.$common.isEmpty(newVal) && !regex.test(newVal)) {
        return callback(new Error('请输入数字'));
      }
      this.$common.strMaxVerify(rule, value, callback);
    },
  },
  activated () {
    var self = this;
    self.selectedProductCategory = self.categoryTree[0];
    self.$Loading.start();
    Promise.resolve(self.getPermission('productCategory_queryAll') ? self.getList('init') : self.gotoError()).then(() => {
      self.$Loading.finish();
    });
    // 获取属性分类
    this.productAttribute();
    // 获取分类尺码
    this.getClassificationList();
    // 获取质检模板
    this.getAllQuality();
  },
  watch: {
    'productCategory.cnName': function (n, o) {
      this.productCategory.title = n;
    }
  }
};
</script>
<style lang="less">
.productCategoryDome {
  min-width: 1020px;
  flex:1;
  overflow: hidden;
  .categoryCont {
    min-width: 900px;
    height: 100%;
    overflow: auto;
  }
  .treeCont {
    height: 100%;
  }
  .hover-color-ccc {
    cursor: pointer;
    padding: 0 4px;
  }
  .hover-color-ccc:hover {
    background-color: #d5e8fc;
  }
  .categoryDetail {
    width: calc(100% - 370px);
    right: initial;
    left: 360px;
    top:20px;
    bottom:0;
    display: flex;
    flex-direction: column;
    .categoryDetailCont {
      flex: 1;
      overflow: auto;
    }
    .categoryDetailBtn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-shrink: 0;
    }
    .categoryDetailTitle {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
      border-left: 4px solid #2d8cf0;
      padding-left: 6px;
    }
    .categoryForm {
      display: flex;
      flex-wrap: wrap;
      .form-col-item {
        flex:1;
      }
      .ivu-form-item {
        margin-bottom: 18px;
      }
    }
    .platform-category-form {
      .platform-category-card {
        min-width: 280px;
        padding: 0 0 12px;
        box-sizing: border-box;
      }
      .platform-category-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 32px;
        padding: 0 10px;
        background: #f8f8f9;
        border: 1px solid #e8eaec;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
      }
      .platform-category-name {
        font-size: 13px;
        font-weight: bold;
        color: #333;
      }
      .platform-category-status {
        font-size: 12px;
        color: #999;
      }
      .platform-category-status-mapped {
        color: #19be6b;
      }
      .ivu-form-item {
        margin-bottom: 0;
        padding: 12px 10px;
        border: 1px solid #e8eaec;
        border-radius: 0 0 4px 4px;
      }
    }
  }
}
</style>
